(ns frontend.ui.page.fund.view
  (:require [common.localization :as loc]
            [ui.util :as uu]))

;; This file should hold the whole Fund page but this page is currently still
;; coded using the previous style (src/cljs/frontend/view/nev/fund/view.cljs)
;; so what you'll find here is just the "report list" component using the new
;; way of coding UI components.

(defn fund-report-list
  [{:keys [nav-to-report can-add-reports?]} reports]
  (if (empty? reports)
    (if can-add-reports?
      (loc/tr :lp-fund-reports-empty-can-add)
      (loc/tr :lp-fund-reports-empty))
    (into [:div]
          (for [{:keys [id title step]} reports]
            ^{:key id}
            [:div
             {:class    "p-2 flex items-center justify-between
             border border-solid border-base-light-border-paler bg-base-light rounded
             cursor-pointer"
              :on-click #(nav-to-report id)}
             [:span
              {:class "font-semibold"}
              title]
             [:span
              {:class (uu/cm "inline-block p-1 ml-4 mb-0 text-md rounded"
                             (case step
                               :lp-report.step/initialization "text-success-light-text"
                               :lp-report.step/data-gathering "text-success-light-text"
                               :lp-report.step/review "text-warning-light-text"
                               :lp-report.step/pending-approval "text-success-light-text"
                               :lp-report.step/publishing-queue "text-success-light-text"
                               :lp-report.step/approved "text-bg-base-light-text"
                               :lp-report.step/published "text-success-light-text"
                               "text-bg-base-light-text"))}
              step]]))))
